import { isAxiosError } from "axios"
import { posthog } from "posthog-js"

export type ErrorSource = "router" | "error_boundary"

/**
 * Client errors from the API (401 before the login redirect, 403 on
 * permission-gated pages, 404…) are expected outcomes, not crashes.
 */
export const isExpectedError = (error: unknown) => {
  const status = isAxiosError(error) ? error.response?.status : undefined
  return status !== undefined && status >= 400 && status < 500
}

/**
 * Send an error caught by React (router CatchBoundary or ErrorBoundary) to
 * PostHog error tracking. React swallows these, so PostHog's exception
 * autocapture never sees them.
 */
export function reportError(
  error: unknown,
  source: ErrorSource,
  componentStack?: string | null,
) {
  if (isExpectedError(error)) return
  try {
    posthog.captureException(error, {
      error_source: source,
      ...(componentStack ? { component_stack: componentStack } : {}),
    })
  } catch {
    // Reporting must never break the error UI
  }
}
